<template lang="html">
  <div class="notification-wrapper">
    <div v-if="notificationInfo" class="message">
      <span
        class="msg"
        v-html="generateMessage(JSON.parse(notificationInfo.msg_message))"
      ></span>
      <span class="msg-time">{{
        getLocalTime(notificationInfo.msg_date)
      }}</span>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'notification',
  props: {
    notification: {
      required: true
    }
  },
  data () {
    return {
      notificationInfo: null
    }
  },
  mounted () {
    this.getNotification()
  },
  methods: {
    getLocalTime (time) {
      return this.$moment
        .utc(time)
        .local()
        .format('h:mm')
    },
    async getNotification () {
      let params = {
        id: this.notification
      }
      await api
        .getNotification(params)
        .then(res => {
          this.notificationInfo = res.data.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    getDate (date) {
      return this.$moment(date).format('DD.MM.YYYY HH:mm')
    }
  },
  computed: {
    generateMessage () {
      return notification => {
        if (notification.type === 'new') {
          return this.$t('profile.notifications.new', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id
          })
        }
        if (notification.type === 'new-buyer') {
          return this.$t('profile.notifications.new-buyer', {
            name: notification.pro_name,
            id: notification.off_id,
            quantity: notification.off_quantity,
            price: notification.price,
            currency: notification.cur_id,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'sold-out') {
          return this.$t('profile.notifications.sold-out', {
            name: notification.pro_name
          })
        }
        if (notification.type === 'reject-buyer') {
          return this.$t('profile.notifications.reject-buyer', {
            username: notification.seller_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'reject-seller') {
          return this.$t('profile.notifications.reject-seller', {
            username: notification.buyer_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'rating') {
          return this.$t('profile.notifications.rating', {
            comment: notification.comment,
            rating: notification.rating,
            username: notification.usr_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'near-exp-seller') {
          return this.$t('profile.notifications.near-exp-seller', {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name
          })
        }
        if (notification.type === 'near-exp-buyer') {
          return this.$t('profile.notifications.near-exp-buyer', {
            date: this.getDate(notification.pro_expiry),
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-seller-sold-out') {
          return this.$t('profile.notifications.expired-seller-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-seller-price') {
          return this.$t('profile.notifications.expired-seller-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            offCount: notification.off_count
          })
        }
        if (notification.type === 'expired-seller-no-buyers') {
          return this.$t('profile.notifications.expired-seller-no-buyers', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-buyer-sold-out') {
          return this.$t('profile.notifications.expired-buyer-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id
          })
        }
        if (notification.type === 'expired-buyer-price') {
          return this.$t('profile.notifications.expired-buyer-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            price: notification.price,
            date: this.getDate(notification.pro_expiry),
            currency: notification.cur_id,
            mun_unit: notification.mun_unit
          })
        }
        if (notification.type === 'expired-buyer-unsold') {
          return this.$t('profile.notifications.expired-buyer-unsold', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'seller-gave-up') {
          return this.$t('profile.notifications.seller-gave-up', {
            username: notification.seller_username,
            name: notification.pro_name
          })
        }
        if (notification.type === 'new-product-admin') {
          return this.$t('profile.notifications.new-product-admin', {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'three-day-seller') {
          return this.$t('profile.notifications.three-day-seller', {
            username: localStorage.getItem('userName'),
            name: notification.pro_name,
            date: this.getDate(notification.pro_expiry),
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'renew-product') {
          return this.$t('profile.notifications.renew-product', {
            username: notification.usr_username,
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'admin-deleted') {
          return this.$t('profile.notifications.admin-deleted', {
            name: notification.pro_name
          })
        }
        if (notification.type === 'admin-rating') {
          return this.$t('profile.notifications.admin-rating', {
            comment: notification.comment,
            rating: notification.rating,
            usernameFrom: notification.usr_username_from,
            usernameTo: notification.usr_username_to
          })
        }
        if (notification.type === 'removed-product-admin') {
          return this.$t('profile.notifications.removed-product-admin', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            username: notification.usr_username
          })
        }
        if (notification.type === 'offer-edit') {
          return this.$t('profile.notifications.offer-edit', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            buyerUsername: notification.buyer_username,
            quantity: notification.off_quantity,
            price: notification.price
          })
        }

        if (
          notification.type === 'three-day-admin' ||
          notification.type === 'near-exp-admin'
        ) {
          return this.$t('profile.notifications.three-day-admin', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            date: this.getDate(notification.pro_expiry)
          })
        }
        if (notification.type === 'expired-admin-price') {
          return this.$t('profile.notifications.expired-admin-price', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id,
            offCount: notification.off_count
          })
        }
        if (notification.type === 'expired-admin-no-buyers') {
          return this.$t('profile.notifications.expired-admin-no-buyers', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'expired-admin-sold-out') {
          return this.$t('profile.notifications.expired-admin-sold-out', {
            name: notification.pro_name,
            link:
              window.location.origin +
              '/' +
              this.$route.params.lang +
              '/details/' +
              notification.pro_id
          })
        }
        if (notification.type === 'new-user-admin') {
          return this.$t('profile.notifications.new-user-admin', {
            cnt_name: notification.cnt_name,
            org_contact: notification.org_contact,
            org_id: notification.org_id,
            org_pib: notification.org_pib,
            osr_name: notification.osr_name,
            otp_name: notification.otp_name,
            type: notification.type,
            usr_address: notification.usr_address,
            usr_email: notification.usr_email,
            usr_name: notification.usr_name,
            usr_phone_number: notification.usr_phone_number,
            usr_postal_code: notification.usr_postal_code,
            usr_region: notification.usr_region,
            usr_username: notification.usr_username
          })
        }
        if (notification.type === 'seller-changed') {
          return this.$t('profile.notifications.seller-changed', {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          })
        }
        if (notification.type === 'buyer-changed') {
          return this.$t('profile.notifications.buyer-changed', {
            newUsername: notification.new_usr_username,
            newAddress: notification.new_usr_address,
            newCountry: notification.new_cnt_name,
            newPhone: notification.new_usr_phone_number,
            newRegion: notification.new_usr_region,
            newPostal: notification.new_usr_postal_code,
            oldUsername: notification.old_usr_username,
            oldAddress: notification.old_usr_address,
            oldCountry: notification.old_cnt_name,
            oldPhone: notification.old_usr_phone_number,
            oldRegion: notification.old_usr_region,
            oldPostal: notification.old_usr_postal_code
          })
        }
        return notification.type
      }
    }
  },
  watch: {
    notification: {
      handler: function () {
        this.getNotification()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-wrapper {
  .message {
    padding: 10px 15px;
    // background: #F3F3F3;
    border-radius: 10px 10px 10px 0px;
    // opacity: 0.8;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-height: max-content;
    max-width: calc(100% - 30px);
    overflow: hidden;
    word-break: break-word;

    .msg {
      margin-bottom: 5px;
      text-align: left;
      font-weight: 500;
      font-size: 13px;
      line-height: 17px;
      letter-spacing: 0.02em;

      a {
        color: #606060;
      }
    }
    .msg-time {
      align-self: flex-end;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      letter-spacing: 0.06em;
    }
  }
}
.card-wrapper {
  width: 500px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.08);
  margin-bottom: 17px;
  position: relative;

  .card-header {
    height: 74px;
    border-bottom: 1px solid #f4f4f4;
    padding: 15px;
    padding-top: 6px;
    box-sizing: border-box;
    display: flex;
    .userImg {
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 6px;
      margin-bottom: 40px;

      img {
        width: 100%;
      }
    }
    .mainDataM {
      padding-left: 20px;
      text-align: left;
      .dataName {
        margin-bottom: 5px;
      }
    }
  }
  .card-messages {
    padding: 15px;
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
    height: 430px;
    overflow-y: auto;
    // justify-content: center;
    @import '@/assets/scss/scrollbarStyles.scss';
    @include scrollbar;
    box-sizing: border-box;

    .message {
      padding: 10px 15px;
      background: #f3f3f3;
      border-radius: 10px 10px 10px 0px;
      opacity: 0.6;
      margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      min-height: max-content;
      max-width: calc(100% - 30px);
      overflow: hidden;
      word-break: break-word;
      display: flex;
      flex-direction: column;

      .msg {
        margin-bottom: 5px;
        text-align: left;
        font-weight: 500;
        font-size: 13px;
        line-height: 17px;
        letter-spacing: 0.02em;
      }
      .msg-time {
        align-self: flex-end;
        font-weight: 500;
        font-size: 11px;
        line-height: 13px;
        letter-spacing: 0.06em;
      }
    }
    .my-msg {
      align-self: flex-end;
      border-radius: 10px 10px 0px 10px;
      background: #fff4f1;
    }
  }
}
</style>
<style>
.dropdown .msg a {
  color: #606060;
}
</style>
